import PropTypes from 'prop-types';
import { Picture } from '@bwoty-web/styleguide';
import LinkPush from './linkPush';
import { sectionKeys } from '../sections/helper';
import './easyTravel.scss';

const EasyTravel = ({ content, changeSection }) => {
  return (
    <LinkPush
      onClick={() => {
        changeSection(sectionKeys.locationAndTransfer);
        window.dataLayer.push({
          event: 'HotelPagePush',
          hotelpagepush: 'Click EasyTravel',
        });
      }}
    >
      <Picture
        className="gw-easy-travel__logo"
        sources={content.image.sources}
        lazy
      />
      <span>{content.title}</span>
    </LinkPush>
  );
};

EasyTravel.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      sources: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  changeSection: PropTypes.func.isRequired,
};

export default EasyTravel;
